import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import useAgency from 'features/Agency/useAgency';
import ChargeHelper from 'features/Charge/chargeHelper';
import useCharge from 'features/Charge/useCharge';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

ChargeStationListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  isAdmin: PropTypes.bool,
};

function ChargeStationListFilterView({ isAdmin, onCancel, onApply, closeDropdown }) {
  // MARK: ---- PROPERTIES ----
  const [selectedAgency, setSelectedAgency] = useState();
  const [filterStatus, setFilterStatus] = useState('');
  const [filterOperatorId, setFilterOperatorId] = useState('');
  const [filterQ, setFilterQ] = useState('');
  const [filterAgencyId, setFilterAgencyId] = useState('');
  const [filterLandlordId, setFilterLandlordId] = useState('');
  const [filterAreaId, setFilterAreaId] = useState('');
  const [filterVehicleType, setFilterVehicleType] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterManagedBy, setFilterManagedBy] = useState('');
  const [filterTestStation, setFilterTestStation] = useState(0);

  useEffect(() => {
    setFilterStatus(ChargeHelper.Filter.chargeStationList.status);
    setFilterOperatorId(ChargeHelper.Filter.chargeStationList.operatorId);
    setFilterQ(ChargeHelper.Filter.chargeStationList.q);
    setFilterManagedBy(ChargeHelper.Filter.chargeStationList.managedBy);
    setFilterAgencyId(ChargeHelper.Filter.chargeStationList.agencyId);
    setFilterLandlordId(ChargeHelper.Filter.chargeStationList.landlordId);
    setFilterAreaId(ChargeHelper.Filter.chargeStationList.areaId);
    setFilterVehicleType(ChargeHelper.Filter.chargeStationList.vehicleType);
    setFilterType(ChargeHelper.Filter.chargeStationList.type);
    setFilterTestStation(ChargeHelper.Filter.chargeStationList.isTestStation);
  }, [ChargeHelper.Filter.chargeStationList]);
  const { operatorList, operatorOptions } = useAgency();
  const { managementObjectOptions } = useCharge();
  // khu vuc
  const areaTree = useSelector((state) => state.app.areaTree);
  const areaProvinceList = useMemo(() => {
    return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
  }, [areaTree]);
  const areaProvinceOptions = useMemo(() => {
    return _.map(areaProvinceList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaProvinceList]);
  const [selectedAreaProvince, setSelectedAreaProvince] = useState();
  const areaDistrictList = useMemo(() => {
    if (!selectedAreaProvince) return [];
    return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
  }, [areaTree, selectedAreaProvince]);
  const areaDistrictOptions = useMemo(() => {
    return _.map(areaDistrictList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaDistrictList]);
  const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();
  useEffect(() => {
    const areaId = ChargeHelper.Filter.chargeStationList.areaId;
    if (Utils.isValid(areaId)) {
      const area = ChargeHelper.Utils.getAreaById([areaTree], areaId);
      console.log({ area });
      if (area?.typeCode === 'P') {
        setSelectedAreaProvince(area);
      } else {
        setSelectedAreaDistrict(area);
        const parentAreaId = area?.parentId;
        if (Utils.isValid(parentAreaId)) {
          setSelectedAreaProvince(ChargeHelper.Utils.getAreaById([areaTree], parentAreaId));
        }
      }
    }
  }, [ChargeHelper.Filter.chargeStationList, areaTree]);
  useEffect(() => {
    const agencyId = ChargeHelper.Filter.chargeStationList.agencyId;
    if (Utils.isValid(agencyId)) {
      AgencyHelper.API.requestAgencyDetail(ChargeHelper.Filter.chargeStationList.agencyId).then(
        (row) => {
          if (row) {
            setSelectedAgency({
              id: row?.agencyId,
              name: row?.name,
              item: row,
            });
            setFilterManagedBy(row.primaryRole);
          }
        }
      );
    }
  }, [ChargeHelper.Filter.chargeStationList]);
  const dropdownAgencyEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="agencyId_filter_dropdowns"
        name="agencyId_filter_dropdowns"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between 
              ${filterManagedBy === '' ? 'disabled' : ''
              }`}
            type="button"
          >
            {selectedAgency
              ? selectedAgency?.name
              : filterManagedBy === AgencyConstants.AgencyRole.INVESTOR
                ? 'Chọn nhà đầu tư'
                : 'Chọn chủ mặt bằng'}
          </button>
        }
        selectedValue={selectedAgency}
        subTitleType="email"
        dropdownMenuItems={[{ name: 'AGENCY', role: 'AGENCY' }]}
        getSubItems={async (item) => {
          return AgencyHelper.API.requestGetAgencyList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
            role:
              filterManagedBy === AgencyConstants.AgencyRole.INVESTOR
                ? 'INVESTOR'
                : 'LANDLORD',
          }).then((data) => {
            return {
              values: data.agencies?.map((row) => ({
                id: row?.agencyId,
                name: row?.name,
                item: row,
                email: row?.email,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedAgency(value);
          if (filterManagedBy === AgencyConstants.AgencyRole.INVESTOR) {
            setFilterAgencyId(value?.id);
          } else {
            setFilterLandlordId(value?.id);
          }
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        disabled={filterManagedBy === ''}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'AGENCY',
          role: 'AGENCY',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedAgency(null);
              setFilterAgencyId('');
              setFilterLandlordId('');
            })}
          </div>
        }
      />
    );
  }, [selectedAgency, filterManagedBy]);

  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    ChargeHelper.Filter.chargeStationList = {
      ...ChargeHelper.Filter.chargeStationList,
      status: filterStatus,
      operatorId: filterOperatorId,
      q: filterQ,
      managedBy: filterManagedBy,
      agencyId: filterAgencyId,
      landlordId: filterLandlordId,
      areaId: filterAreaId,
      vehicleType: filterVehicleType,
      type: filterType,
      page: 0,
      isTestStation: filterTestStation,
    };
    if (onApply) onApply();
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    setSelectedAgency(null);
    setSelectedAreaProvince(null);
    setSelectedAreaDistrict(null);
    ChargeHelper.Filter.chargeStationList = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: '',
      operatorId: '',
      q: '',
      managedBy: '',
      agencyId: '',
      landlordId: '',
      areaId: '',
      vehicleType: '',
      type: '',
      isTestStation: 0,
    };
    if (onCancel) onCancel();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo mã trạm sạc, tên trạm sạc, địa chỉ..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* nha dieu hanh */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Nhà điều hành')}
          <KTBSDropdown
            name="operator_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(operatorList, (item) => item.operatorId === filterOperatorId)?.name ??
                  'Tất cả'}
              </button>
            }
            selectedValue={ChargeHelper.Filter.chargeStationList?.operatorId}
            dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...operatorOptions]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterOperatorId(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* doi tuong quan ly */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Đối tượng quản lý')}
          <KTBSDropdown
            name="managementObject_filter"
            toggleElement={
              <button
                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                type="button"
              >
                {_.find(managementObjectOptions, (item) => item.value === filterManagedBy)
                  ?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterManagedBy}
            dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...managementObjectOptions]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterManagedBy(value);
              setSelectedAgency(null);
              setFilterAgencyId('');
              setFilterLandlordId('');
            }}
            isDropdownForm={true}
          />
        </div>
        {/* ndt nq hoac chu dat */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel(
            filterManagedBy === AgencyConstants.AgencyRole.INVESTOR
              ? 'Nhà đầu tư NQ'
              : filterManagedBy === AgencyConstants.AgencyRole.LANDLORD
                ? 'Chủ mặt bằng'
                : 'NĐT/Chủ mặt bằng',
          )}
          {dropdownAgencyEl}
        </div>
        {/* loc theo loai phuong tien */}
        <div className="col mb-4 px-2">
          {UIHelper.buildFormLabel('Loại phương tiện')}
          <KTBSDropdown
            name="operator"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.vehicleTypeOptions,
                  (item) =>
                    item?.value === filterVehicleType
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterVehicleType}
            dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...ChargeHelper.Data.vehicleTypeOptions]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterVehicleType(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* trang thai */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Trạng thái trạm sạc')}
          <KTBSDropdown
            name="status_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargeStationStatusOptions,
                  (item) => item.value === filterStatus
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={ChargeHelper.Filter.chargeStationList?.status}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.chargeStationStatusOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterStatus(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* loc theo loai tru sac */}
        <div className="col-sm-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Loại trụ sạc')}
          <KTBSDropdown
            name="type"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargePointTypeOptions,
                  (item) =>
                    item?.value === filterType
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterType}
            dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...ChargeHelper.Data.chargePointTypeOptions]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterType(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* tinh/thanh pho */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Tỉnh/Thành phố')}
          <KTBSDropdown
            name="province_filter"
            toggleElement={
              <button
                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                type="button"
              >
                {selectedAreaProvince?.name ?? 'Chọn tỉnh/thành phố'}
              </button>
            }
            selectedValue={selectedAreaProvince?.areaId}
            dropdownMenuItems={areaProvinceOptions}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setSelectedAreaProvince(_.find(areaProvinceList, (item) => item.areaId === value));
              setFilterAreaId(value);
            }}
            isDropdownForm={true}
            searchable
            liveSearch={false}
            onTextChanged={(text) => { }}
            footerEl={
              <div
                className="p-4 position-sticky sticky-bottom bg-white"
                style={{
                  borderTop: `1px solid ${AppColors.gray[300]}`,
                }}
              >
                {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                  setSelectedAreaProvince(null);
                  setFilterAreaId('');
                  setSelectedAreaDistrict(null);
                })}
              </div>
            }
          />
        </div>
        {/* quan/huyen */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Phường/Xã')}
          <KTBSDropdown
            name="district"
            toggleElement={
              <button
                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                type="button"
              >
                {selectedAreaDistrict?.name ?? 'Chọn phường/xã'}
              </button>
            }
            selectedValue={selectedAreaDistrict?.areaId}
            dropdownMenuItems={areaDistrictOptions}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              const area = _.find(areaDistrictList, (item) => item.areaId === value);
              setSelectedAreaDistrict(area);
              setFilterAreaId(value);
            }}
            isDropdownForm={true}
            searchable
            liveSearch={false}
            onTextChanged={(text) => { }}
            footerEl={
              <div
                className="p-4 position-sticky sticky-bottom bg-white"
                style={{
                  borderTop: `1px solid ${AppColors.gray[300]}`,
                }}
              >
                {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                  setSelectedAreaDistrict(null);
                  setFilterAreaId(selectedAreaProvince?.areaId ?? '');
                })}
              </div>
            }
          />
        </div>
        <div className="col-12 mb-4 px-4"
          style={{
            borderBottom: `1px dashed ${AppColors.gray[300]}`
          }}
        />
        {/* tram sac test */}
        <div className='d-flex gap-2 align-items-center mb-4'>
          <span style={UIHelper.buildFontStyle('700', '13px', AppColors.gray[800])}>
            Xem trạm sạc test
          </span>
          {UIHelper.buildToggleSwitch(
            filterTestStation,
            () => {
              setFilterTestStation(Number(!filterTestStation));
            }
          )}
        </div>
      </div>
      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default ChargeStationListFilterView;
